
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Endi,Movi,Sald } from "src/app/model/scc.model";
import { OperacaoRepasseBndes } from 'src/app/model/operacao-repasse.model';

@Injectable({
  providedIn: 'root'
})
export class OperacaorepasseBndesService extends FgiBackEndService<OperacaoRepasseBndes> {

  // @Override
  getNewEntity() {
    return new OperacaoRepasseBndes();
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/repasse-bndes/operacoes';
  }

  protocolar(operacao: OperacaoRepasseBndes, apenasValidar: boolean): Observable<OperacaoRepasseBndes> {
    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}/protocolar`, operacao, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<OperacaoRepasseBndes>;
  }

  contratar(operacao: OperacaoRepasseBndes, apenasValidar: boolean): Observable<OperacaoRepasseBndes> {
    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}/contratar`, operacao, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<OperacaoRepasseBndes>;
  }

  cancelar(ideOperacaoRepasse: number): Observable<any> {
    const options: any = blockUi();

    return this.http.post(`${this.BASE_URL}/cancelar/${ideOperacaoRepasse}`, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<any>;
  }

  buscarOperacao(idProtocoloOperacaoBndes): Observable<OperacaoRepasseBndes> {
    return this.http.get(`${this.BASE_URL}/${idProtocoloOperacaoBndes}`).pipe(
        catchError((e) => this.handleError(e))) as Observable<OperacaoRepasseBndes>;
  }

  buscarOperacaoParaCadastroPorTela(idProtocoloOperacaoBndes): Observable<OperacaoRepasseBndes> {
    return this.http.get(`${this.BASE_URL}/${idProtocoloOperacaoBndes}`) as Observable<OperacaoRepasseBndes>;
  }

  exportarOperacao(id): Observable<string> {
    return this.http.get(`${this.BASE_URL}/exportacao/${id}`).pipe(
        catchError((e) => this.handleError(e))) as Observable<string>;
  }
 
  getAmortizacoes(id:number): Observable<Array<Movi>> {
    return this.http.get(`${this.BASE_URL}/amortizacoes/${id}`).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<Movi>>;
  }
  getSaldo(id:number): Observable<Array<Sald>> {
    return this.http.get(`${this.BASE_URL}/saldo-principal-atual/${id}`).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<Sald>>;
  }

  

}